import type {Car} from "../model/model";
import {commonColors, commonTypes} from "./commonOptions";
import {activeLang} from "../main";

export function formatDate(date: String | null): String {
    return date?.split("-")?.map(part => part.trim())?.join(". ")?.concat(".") ?? ""
}

export function formatKilometers(kilometers: Number): String {
    return kilometers.toLocaleString()
}

export function shortCarInfo(car: Car): String {
    let info = `${car.brand} ${car.model}`
    if (car.type) { info += ` ${commonTypes.localName(activeLang(), car.type)}` }
    if (car.color) { info += ` (${commonColors.localName(activeLang(), car.color)})` }
    return info
}